export default __webpack_public_path__ + "static/media/updateDenylist.b42856ca.svg";